<div class="layout-footer"><span class="footer-text" style="margin-right: 5px">Platyplus</span></div>